import { apiPostAsync } from '../common/service-utils'
import * as constants from '../common/constants'
import * as JspUtil from '../common/JspUtil'

export const USER_GET_TFA_DETAILS_DATA = 'USER_GET_TFA_DETAILS_DATA';

export async function requestGlobalId(email, firstName, lastName, globalIdPassword, appUserId, appKey, appPassword, captchaResponse, transitionToken) {
    let redirectUrl = '';
    if (JspUtil.isValueAvailable(window.jspRedirectUrl)) {
        redirectUrl = window.jspRedirectUrl;
    }

    const postData = {
        globalId: email,
        firstName,
        lastName,
        globalIdPassword,
        appKey,
        appUserId,
        appPassword,
        redirectUrl,
        captchaResponse
    };
    if (transitionToken) {
        // Login context, used server side to skip captcha. loginApp may be ANY —
        // appKey must stay the resolved app so the app user can be linked.
        postData.loginUserId = transitionToken.loginUserId;
        postData.loginApp = transitionToken.loginApp;
        postData.password = transitionToken.password;
        // Link the app user that started the transition. Login credentials live on
        // the token (userInputsReducer no longer keeps username/password).
        if (transitionToken.loginUserId) {
            postData.appUserId = transitionToken.loginUserId;
        }
        if (transitionToken.password) {
            postData.appPassword = transitionToken.password;
        }
    }
    const resp = await apiPostAsync(constants.API_REQUEST_GLOBAL_ID, null, postData);
    return { ...resp, redirectUrl };
}

export async function confirmGlobalId(email, firstName, lastName, newPassword, otpCode) {
    const postData = {
        globalId: email,
        firstName,
        lastName,
        newPassword,
        tfaPasscode: otpCode
    };
    return apiPostAsync(constants.API_CONFIRM_GLOBAL_ID, null, postData);
}

export async function registerGlobalIdWithCompany(email, firstName, lastName, loginApp, externalCompanyId, captchaResponse) {
    const postData = {
        globalId: email,
        firstName,
        lastName,
        appKey: loginApp,
        companyId: externalCompanyId,
        captchaResponse,
        createGlobalIdIfNotPresent: 'Y',
        sendEmail: 'Y'
    };
    return apiPostAsync(constants.API_REGISTER_GLOBAL_ID_WITH_COMPANY, null, postData);
}

export async function confirmUserEmail(userId, appKey, redirectUrl, newPassword, otpCode) {
    const postData = {
        userId,
        appKey,
        newPassword,
        otpCode,
        redirectUrl
    };
    return apiPostAsync(constants.API_CONFIRM_USER_EMAIL, null, postData);
}
